module.exports = __webpack_public_path__ + "img/lange_crub_2.ead3af54.jpg";